<div class="columns-wrapper">
    <div class="column">
        <div class="header">
            <div class="title">January</div>
            <div class="number-left">1 Task Left</div>
        </div>
        <div class="content">
            <div class="task-item finished">
                <div class="text">
                    <div>Task Name</div>
                    <div>Jan 28, 19 | 2/5 Complete</div>
                </div>
                <i class="fa fa-ellipsis-v dropdown-toggle" aria-hidden="true" data-toggle="dropdown"></i>
                <ul class="dropdown-menu">
                    <li><a>Edit</a></li>
                    <li><a>Mark As Complete</a></li>
                    <li><a>Move</a></li>
                    <li><a>Repeat</a></li>
                    <li><a>Duplicate</a></li>
                </ul>
            </div>
            <div class="task-item display-flex m-b-sm">
                <i class="fa fa-check-circle mtv-primary-color m-r-sm" aria-hidden="true"></i>
                <div class="text">
                    <div>Task Name</div>
                    <div>Jan 28, 19 | 2/5 Complete</div>
                </div>
                <i class="fa fa-ellipsis-v dropdown-toggle" aria-hidden="true" data-toggle="dropdown"></i>
                <ul class="dropdown-menu">
                    <li><a>Edit</a></li>
                    <li><a>Mark As Complete</a></li>
                    <li><a>Move</a></li>
                    <li><a>Repeat</a></li>
                    <li><a>Duplicate</a></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="column">
        <div class="header">
            <div class="title">February</div>
            <div class="number-left">2 Tasks Left</div>
        </div>
        <div class="content">
            <div class="task-item">
                <i class="fa fa-circle-o mtv-primary-color m-r-sm" aria-hidden="true"></i>
                <div class="text">
                    <div>Task Name</div>
                    <div>Jan 28, 19 | 2/5 Complete</div>
                </div>
                <i class="fa fa-ellipsis-v dropdown-toggle" aria-hidden="true" data-toggle="dropdown"></i>
                <ul class="dropdown-menu">
                    <li><a>Edit</a></li>
                    <li><a>Mark As Complete</a></li>
                    <li><a>Move</a></li>
                    <li><a>Repeat</a></li>
                    <li><a>Duplicate</a></li>
                </ul>
            </div>
            <div class="task-item display-flex m-b-sm">
                <i class="fa fa-check-circle mtv-primary-color m-r-sm" aria-hidden="true"></i>
                <div class="text">
                    <div>Task Name</div>
                    <div>Jan 28, 19 | 2/5 Complete</div>
                </div>
                <i class="fa fa-ellipsis-v dropdown-toggle" aria-hidden="true" data-toggle="dropdown"></i>
                <ul class="dropdown-menu">
                    <li><a>Edit</a></li>
                    <li><a>Mark As Complete</a></li>
                    <li><a>Move</a></li>
                    <li><a>Repeat</a></li>
                    <li><a>Duplicate</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/maintenance-calendar/maintenance-calendar-list/maintenance-calendar-list.component.html